import React from 'react'

export function WalletCard(jsx){
    return(
        <div className="card rounded shadow-sm p-8 p-lg-8 me-10 w-md-100 w-sm-100 w-100 mb-md-10 mb-sm-10 mb-lg-0 mb-10" style={{width: '40%', minHeight: '300px'}}>
            {jsx.props}
        </div>
    )
}